import React, { useRef, useCallback } from 'react'
import { Button, Select, Tooltip } from 'antd'
import * as Icons from '@ant-design/icons'

import { useGlobalShortcut } from 'admin/lib/shortcuts'
import { Matchers } from 'admin/lib/Records'
import { FormRow, FormItem } from 'admin/lib/Forms'
import { Queries } from 'admin/lib/Api'
import { calculateAssignmentOptions } from 'admin/lib/assigneeFunctions'
import { RAW } from 'admin/pages/RecordEdit_v2/common/constants'

export function FormControls({ dataView }) {
  const isLegacyV1 = !dataView

  const { hiddenElement } = useSaveShortcut(!isLegacyV1)
  const users = Queries.useQflowUsers()

  const isRawDataView = dataView === RAW

  return (
    <>
      <FormRow>
        <FormItem label="Status" name="status">
          <Select disabled={isLegacyV1}>
            <Select.Option
              aria-label="Published"
              title={
                isLegacyV1
                  ? null
                  : 'Published (Must be in Enhanced View to select)'
              }
              value="Published"
              disabled={isRawDataView}
            >
              Published
            </Select.Option>
            <Select.Option aria-label="Escalated" value="Escalated">
              Escalated
            </Select.Option>
            <Select.Option aria-label="Failed" value="Failed">
              Failed
            </Select.Option>
            <Select.Option aria-label="Void" value="Void">
              Void
            </Select.Option>
            <Select.Option aria-label="Removed" value="Removed" disabled>
              Removed
            </Select.Option>
            <Select.Option aria-label="New" value="New" disabled>
              New
            </Select.Option>
          </Select>
        </FormItem>

        {hiddenElement}

        {isLegacyV1 && (
          <Tooltip
            title={
              <div>
                This is a Legacy V1 record. If you need to make changes, switch
                to Raw/Enriched View. <br />
                Use the Enriched tab to make changes as Raw will be empty.
                <br />
                Refer to the Ticket for the original values.
              </div>
            }
          >
            <Button
              type="primary"
              style={{ width: '37.5%' }}
              htmlType="submit"
              icon={<Icons.UploadOutlined />}
              disabled={isLegacyV1}
            >
              Save
            </Button>
          </Tooltip>
        )}

        {!isLegacyV1 && (
          <Button
            type="primary"
            style={{ width: '37.5%' }}
            htmlType="submit"
            icon={<Icons.UploadOutlined />}
            disabled={isLegacyV1}
          >
            Save {dataView}
          </Button>
        )}
      </FormRow>

      {users.data && (
        <FormRow style={{ width: '100%' }}>
          <FormItem label="Assignee" name="assignee">
            <Select showSearch={true}>
              {calculateAssignmentOptions(users.data)}
            </Select>
          </FormItem>
        </FormRow>
      )}
    </>
  )
}

function useSaveShortcut(enabled) {
  const submitButtonRef = useRef()

  useGlobalShortcut(
    Matchers.form.save,
    useCallback(() => {
      if (!enabled) {
        return
      }
      document.activeElement.blur()
      submitButtonRef.current.click()
    }, [enabled])
  )

  if (!enabled) {
    return { hiddenElement: null }
  }

  return {
    hiddenElement: <input type="submit" hidden ref={submitButtonRef} />
  }
}
